import { useMemo } from "react";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { EXECUTION_TYPE, OP_RUNNING_MODE } from "../../../../util/varibles/constants";
import { IActivityLog, IHarvest2 } from "../../../../util/varibles/interface";
import FinishStepButton from "../FinishStepButton";

interface ClearningProps {
    prev: IActivityLog
    stepIndex: number
    harvestingSteps: NonNullable<IActivityLog["real_sub_steps"]>
    dischargingSteps: NonNullable<IActivityLog["real_sub_steps"]>
}

export default function Cleaning({ prev, stepIndex, harvestingSteps, dischargingSteps }: ClearningProps) {
    const [operation] = useTrackingOp(state => state.op?.operation as IHarvest2);
    const { execution_type, op_running_mode = OP_RUNNING_MODE.NORMAL } = operation || {};

    const isDone = useMemo(() => {
        if (execution_type === EXECUTION_TYPE.AUTO)
            return false;

        if (op_running_mode !== OP_RUNNING_MODE.DETAIL)
            return !!prev.real_finish_time;

        const remainingFishByTank = harvestingSteps.reduce((result: Record<string, number>, item) => {
            result[item.tank_id] = (result[item.tank_id] || 0) + (item.fish_amount || 0);
            return result;
        }, {});

        dischargingSteps.forEach(item => {
            if (!item.real_finish_time)
                return;

            remainingFishByTank[item.tank_id] = Math.max(
                0,
                (remainingFishByTank[item.tank_id] || 0) - (item.fish_amount || 0) - (item.dead_fish || 0)
            );
        });

        const tankIds = Object.keys(remainingFishByTank);
        return tankIds.length > 0 && tankIds.every(tankId => remainingFishByTank[tankId] <= 0);
    }, [dischargingSteps, execution_type, harvestingSteps, op_running_mode, prev.real_finish_time]);

    return <>
        {isDone && <FinishStepButton name="Cleaning" payload={{ step_new: -1, current_process: stepIndex }} />}
    </>
}
